import State from 'store/State';
import { useSelector } from 'react-redux';
import { AppMode } from './AppMode';

export const selectAppMode = (state: State) => state.app.general.appMode;

export const selectBuildVersion = (state: State) =>
    state.app.general.buildVersion;

export const selectAppTimestamp = (state: State) =>
    state.app.general.appTimestamp;

export const selectMachineId = (state: State) => state.app.general.machineId;

export const useSelectAppMode = () => useSelector(selectAppMode);

export const useSelectBuildVersion = () => useSelector(selectBuildVersion);

export const useSelectIsAppModeStandalone = () => {
    const appMode = useSelectAppMode();
    return appMode === AppMode.STANDALONE;
};

export const useSelectIsAppModeNewportSingleWidget = () => {
    const appMode = useSelectAppMode();
    return appMode === AppMode.EMBEDDED_SINGLE_WIDGET;
};

export const useSelectIsAppModeNewportLinkedPalette = () => {
    const appMode = useSelectAppMode();
    return appMode === AppMode.EMBEDDED_DASHBOARD;
};
